import React from "react";
import { toast } from "react-toastify";
import { Link, useLocation } from "react-router-dom";

import { v4 as uuidv4 } from "uuid";

import { ReactComponent as SendIcon } from "../../../../assets/send-icon.svg";
import ChatHeaderSkeleton from "./skeleton/ChatHeaderSkeleton";
import ChatBodySkeleton from "./skeleton/ChatBodySkeleton";
import handleServerError, {
  handleUnauthorizedError,
} from "../../../../api/helpers/handleErrorResponses.util";
import UserInputViewer from "../../../global/UserInputViewer";
import { sendMessageApi } from "../../../../api/dashboardApi";

import "./style.css";
import "./chat-day-container/style.css";
import "./single-message/style.css";

import _ from "lodash";
import LoadingSM from "../../loading/LoadingSM";
import { createChatMessage } from "../SeletectedChat";

const ChatContainer = (props) => {
  const { selectedChat, isInitialLoading, isDisabledChat = false } = props;

  const location = useLocation();

  let { id, propertyDetails = {} } = selectedChat?.bookingDetails || {};

  const locationChat = location.state?.selectedChat || {};

  if (_.isEmpty(propertyDetails) && !_.isEmpty(locationChat.propertyDetails)) {
    propertyDetails = locationChat.propertyDetails;
    id = locationChat.bookingId;
  }

  const hanldeSendMessage = (e) => {
    e.preventDefault();

    const value = e.target[0].value;
    const maxLength = 255;

    if (!value) {
      return;
    }

    const data = {
      bookingId: id,
      message: value,
    };

    if (value.length > maxLength) {
      toast.error(`Message exceeds maximum length of ${maxLength} characters.`);
      return;
    }

    const chatBody = document.getElementById("chat-body");
    const messagesContainer = document.getElementById("messages-container");

    const lastDayContainer = messagesContainer?.querySelector(
      ".chat-day-container:last-child .chat-day-body"
    );

    if (!messagesContainer || !lastDayContainer) {
      toast.error(
        "An error occured while sending message. Please try again later."
      );
      return;
    }

    const msgElement = createChatMessage({
      id: uuidv4(),
      message: value,
      userType: "GUEST_USER",
      isSeen: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });

    lastDayContainer.appendChild(msgElement);

    chatBody.scrollTop = chatBody.scrollHeight;

    e.target[0].value = "";

    sendMessageApi(data)
      .then((res) => {
        const { message } = res.data;

        msgElement.setAttribute("data-message-id", message.id);
      })
      .catch((err) => {
        msgElement.remove();
        e.target[0].value = value;

        if (err.status >= 500) {
          return handleServerError(err);
        }

        if (err.status === 401) {
          return handleUnauthorizedError(err);
        }

        toast.error(
          "An error occured while sending message. Please try again later."
        );
      });
  };

  return (
    <article
      className="chat-container box-border"
      aria-label={`Chat with ${propertyDetails?.name}`}
    >
      <div className="chat-header">
        {(!isInitialLoading || propertyDetails?.name) && (
          <>
            <UserInputViewer
              tag="h3"
              className="chat-title"
              text={propertyDetails?.name}
            />

            <div className="chat-header-extra">
              reservation id :{" "}
              <Link
                to={`/dashboard/bookings/${id}`}
                aria-label={`Reservation ID number ${id}`}
              >
                #{id}
              </Link>
            </div>
          </>
        )}

        {isInitialLoading && !propertyDetails.name && <ChatHeaderSkeleton />}
      </div>
      <div
        id="chat-body"
        className="chat-body"
        role="log"
        aria-live="polite"
        data-is-updating={false}
        data-all-old-messages-loaded={true}
        data-loading-error={false}
      >
        {isInitialLoading && <ChatBodySkeleton />}

        <div className="loading-small">
          <LoadingSM />
        </div>
        <div id="loading-error" className="loading-error error-msg">
          <p>Failed to load messages. Please try again later.</p>
        </div>

        <div id="messages-container"></div>
      </div>

      {isDisabledChat ? (
        <p
          className="past-reservation-phase"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            margin: 0,
            paddingBlock: "12px",
          }}
        >
          Messaging is available only for future and ongoing active bookings.
        </p>
      ) : (
        <></>
      )}

      {!isDisabledChat && (
        <form className="chat-footer" onSubmit={hanldeSendMessage}>
          <input
            type="text"
            placeholder="Start typing..."
            aria-label="Type your message here"
          />
          <button
            type="submit"
            aria-label="Send message"
            disabled={isInitialLoading}
          >
            <SendIcon />
          </button>
        </form>
      )}
    </article>
  );
};

export default ChatContainer;
